// wood craft shapes custom javascript file

var decrement_list = document.getElementsByClassName("qty_minus");
var increment_list = document.getElementsByClassName("qty_plus");
var quantity_list = document.getElementsByClassName("qty_input");


function get_id(product_id){
    var id_only = product_id.split('_')[1];
    var input_id = "updates_" + id_only;
    return input_id;
}

function decrement_qty(){
    var id_selector = this.getAttribute('id');
    var prod = get_id(id_selector);
    const product_qty = document.getElementById(prod);
    if (product_qty.value <= 1){
        product_qty.value = 1
    } else {
        product_qty.value --;
    }

    document.getElementById('cartform').submit();
}

function increment_qty(){
    var id_selector = this.getAttribute('id');
    var prod = get_id(id_selector);
    const product_qty = document.getElementById(prod);
    product_qty.value ++;
    document.getElementById('cartform').submit();
}

window.onload = function () {
	for (i = 0; i < decrement_list.length; i++) {
		decrement_list[i].onclick = decrement_qty; 
	}

    for (i = 0; i < increment_list.length; i++) {
		increment_list[i].onclick = increment_qty; 
	}

    for (i = 0; i < quantity_list.length; i++) {
		quantity_list[i].addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                document.getElementById('cartform').submit();
            }
        }) 
	}
}